import { isWechat } from "@/utils/isTerminal.js";
import { getOpenIdByCode, registerShortUrl } from "@/api/wechat.js";
import Storage from "good-storage";
import { Toast } from "vant";

const OPEN_ID_KEY = "NRC_H5_OPEN_ID";
const RETURN_ROUTE_KEY = "NRC_H5_WX_AUTH_RETURN_ROUTE";
const PENDING_ACTION_KEY = "NRC_H5_WX_AUTH_PENDING_ACTION";
const PENDING_ACTION_TTL = 5 * 60 * 1000;
// 统一由微信授权服务根据公众号配置生成 snsapi_base 授权地址，前端不再硬编码 AppID 和回调地址。
const WX_OPEN_ID_CODE_URL = "https://wxauth.hulian120.com/hsjmp/mp/getOpenIdCode";

export function getOpenId() {
  return Storage.get(OPEN_ID_KEY);
}

function setOpenId(openId) {
  return Storage.set(OPEN_ID_KEY, openId);
}

function saveReturnRoute(fullPath) {
  Storage.set(RETURN_ROUTE_KEY, fullPath);
}

function savePendingAction(action) {
  if (!action) return;
  Storage.set(PENDING_ACTION_KEY, {
    ...action,
    expiresAt: Date.now() + PENDING_ACTION_TTL,
  });
}

export function getPendingAction() {
  const pending = Storage.get(PENDING_ACTION_KEY);
  if (!pending || !pending.expiresAt || pending.expiresAt <= Date.now()) {
    Storage.remove(PENDING_ACTION_KEY);
    return null;
  }
  return pending;
}

export function clearPendingAction() {
  Storage.remove(PENDING_ACTION_KEY);
}

export function popReturnRoute() {
  let route = Storage.get(RETURN_ROUTE_KEY);
  Storage.remove(RETURN_ROUTE_KEY);
  return route;
}

function cleanCodeFromUrl() {
  let url = new URL(window.location.href);
  url.searchParams.delete("code");
  url.searchParams.delete("state");
  window.history.replaceState({}, document.title, url.toString());
}

// 跳转去微信授权。落地页(redirect_uri)用的是wxauth这个中转服务，不是咱们自己的域名，
// 跳之前先"注册"一下真正要回到的地址(咱们自己的根地址，不带hash)，换一个短state。
function redirectToWxAuth(currentFullPath) {
  saveReturnRoute(currentFullPath);
  let ownBaseUrl = window.location.origin + window.location.pathname;

  registerShortUrl(ownBaseUrl)
    .then((r) => {
      // TODO 待实测确认：这个接口的真实返回结构我们没有实际抓到过，这里先按最常见的几种
      // 可能性做兼容(直接是字符串 / 包在shortsSence字段里 / 包在state字段里)，
      // 如果实测发现state不对，把接口真实返回的内容发我，这里再精确调整
      let state = typeof r === "string" ? r : r.shortsSence || r.state || r.shortSence || "";
      if (!state) {
        Toast("获取跳转凭证失败，请重试");
        return;
      }
      window.location.href = `${WX_OPEN_ID_CODE_URL}?shareKey=${encodeURIComponent(state)}`;
    })
    .catch(() => {
      Toast("拉起微信授权失败，请重试");
    });
}

/**
 * App启动时调用一次：检查地址栏上有没有微信授权跳转回来带的code，有就换成openId存起来。
 */
export function handleWxAuthReturn() {
  return new Promise((resolve) => {
    let params = new URLSearchParams(window.location.search);
    let code = params.get("code");
    if (!code) {
      resolve(false);
      return;
    }
    getOpenIdByCode({ code })
      .then((r) => {
        setOpenId(r);
        cleanCodeFromUrl();
        resolve(true);
      })
      .catch(() => {
        cleanCodeFromUrl();
        resolve(false);
      });
  });
}

/**
 * 需要openId才能进行的操作(目前就是发起支付前)，统一用这个包一层。
 */
export function ensureOpenId(currentFullPath, action, pendingAction) {
  if (!isWechat) {
    action && action();
    return;
  }
  let openId = getOpenId();
  if (openId) {
    action && action();
    return;
  }
  savePendingAction(pendingAction);
  redirectToWxAuth(currentFullPath);
}
